import { createSlice } from '@reduxjs/toolkit';

import { cartApi } from '../services/cartApi';

export const shoppingBag = createSlice({
  name: 'shoppingBag',
  initialState: {
    hasItemExceedingStock: false,
    updatingCartDrawerItem: false,
    deletingCartDrawerItem: false,
  },
  reducers: {
    setHasItemExceedingStock: (state, action) => {
      state.hasItemExceedingStock = action.payload.hasItemExceedingStock;
    },
  },
  extraReducers: builder => {
    builder.addMatcher(
      cartApi.endpoints.updateCartDrawerItemQuantity.matchPending,
      state => {
        state.updatingCartDrawerItem = true;
      }
    );
    builder.addMatcher(
      cartApi.endpoints.updateCartDrawerItemQuantity.matchFulfilled,
      state => {
        state.updatingCartDrawerItem = false;
      }
    );
    builder.addMatcher(
      cartApi.endpoints.deleteCartDrawerItem.matchPending,
      state => {
        state.deletingCartDrawerItem = true;
      }
    );
    builder.addMatcher(
      cartApi.endpoints.deleteCartDrawerItem.matchFulfilled,
      state => {
        state.deletingCartDrawerItem = false;
      }
    );
  },
});

export const { setHasItemExceedingStock } = shoppingBag.actions;
